import React from 'react';
import './OurCreations.css';

const creations = [
    {
        title: 'Robe de soirée élégante',
        description: 'Une robe de soirée somptueuse en soie, conçue pour sublimer chaque silhouette lors des grandes occasions.',
        imageUrl: require('../assets/creation1.jpg')
    },
    {
        title: 'Sac à main chic',
        description: 'Un sac à main luxueux alliant style et fonctionnalité, confectionné en cuir premium par nos artisans.',
        imageUrl: require('../assets/creation2.jpg')
    },
    {
        title: 'Souliers raffinés',
        description: 'Des souliers élégants pensés pour le confort et le style, parfaits pour toutes vos sorties.',
        imageUrl: require('../assets/creation3.jpg')
    }
];

const OurCreations = () => (
    <div className="our-creations">
        <h1 className="creations-title">Nos Créations</h1>
        <div className="creations-gallery">
            {creations.map((creation, index) => (
                <div className="creation-card" key={index}>
                    <div className="creation-image-wrapper">
                        <img src={creation.imageUrl} alt={creation.title} className="creation-image" />
                    </div>
                    <div className="creation-info">
                        <h2 className="creation-title">{creation.title}</h2>
                        <p className="creation-description">{creation.description}</p>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default OurCreations;